import {
  buildFetchModel
} from './model.common';

// 后台系统配置项列表
export const AdminSystemSettingListModel = buildFetchModel({
  url: 'admin/setting/list',
  defaultMethod: 'GET'
})

// 编辑系统配置项列表
export const AdminSystemSettingEditModel = buildFetchModel({
  url: 'admin/setting/set',
  defaultMethod: 'POST'
})

// 学院删除
export const SchoolCollegeItemDeleteModel = buildFetchModel({
  url: 'school/college/delete',
  defaultMethod: 'POST'
});

// 学院信息表
export const SchoolCollegeItemCreateOrUpdateModel = buildFetchModel({
  url: 'school/college/create/:id',
  defaultMethod: 'POST'
});

//教材计划列表
export const SchoolAdminToolBookStatementClassCourseList = buildFetchModel({
  url: 'tool/book/statement/class/course/list',
  defaultMethod: 'GET'
});

//课程类型列表
export const SchoolAdminToolBookStatementCourseTypeList = buildFetchModel({
  url: 'tool/book/statement/coursetype/list',
  defaultMethod: 'GET'
});

//结算班级列表
export const SchoolAdminToolBookStatementClassList = buildFetchModel({
  url: 'tool/book/statement/class/list',
  defaultMethod: 'GET'
});

//统一设置折扣
export const SchoolAdminToolBookStatementBookDiscount = buildFetchModel({
  url: 'tool/book/statement/:book_statement_id/book/discount',
  defaultMethod: 'POST'
});

//编辑教材计划列表书目
export const SchoolAdminToolBookStatementBookCatalogCreate = buildFetchModel({
  url: 'tool/book/statement/book/catalog/create/:book_statement_catalog_id',
  defaultMethod: 'POST'
});

//删除教材计划列表书目
export const SchoolAdminToolBookStatementClassCourseDelete = buildFetchModel({
  url: 'tool/book/statement/class/course/delete',
  defaultMethod: 'POST'
})
//结算学院列表
export const ToolBookStatementCollegeListModel = buildFetchModel({
  url: 'tool/book/statement/college/list',
  defaultMethod: 'Get'
});
//结算学院详情
export const ToolBookStatementCollegeBookStatementModel = buildFetchModel({
  url: 'tool/book/statement/college/:book_statement_college_id',
  defaultMethod: 'Get'
});

//删除结算学院列表
export const ToolBookStatementCollegeBookStatementDeleteModel = buildFetchModel({
  url: 'tool/book/statement/college/:book_statement_college_id/delete',
  defaultMethod: 'POST'
});

//创建结算学院列表
export const ToolBookStatementBookStatementIdCollegeCreateModel = buildFetchModel({
  url: 'tool/book/statement/:book_statement_id/college/create/:book_statement_college_id',
  defaultMethod: 'POST'
});

//批量设置预付款
export const ToolBookStatementBookStatementIdCollegeAdvancePaymentModel = buildFetchModel({
  url: 'tool/book/statement/:book_statement_id/college/advance/payment',
  defaultMethod: 'POST'
});

//创建/编辑结算单
export const SchoolAdminToolBookStatementCreateOrChangeModel = buildFetchModel({
  url: 'tool/book/statement/:book_statement_id',
  defaultMethod: 'POST'
});

//结算批次列表
export const SchoolAdminToolBookStatementListModel = buildFetchModel({
  url: 'tool/book/statement/list',
  defaultMethod: 'GET'
});

//学生列表
export const SchoolAdminToolBookStatementStudentListModel = buildFetchModel({
  url: 'tool/book/statement/student/list',
  defaultMethod: 'GET'
});

//学生导入列表
export const SchoolAdminToolBookStatementStudentCourseListModel = buildFetchModel({
  url: 'tool/book/statement/student/course/list',
  defaultMethod: 'GET'
});

//数据导入列表
export const SchoolAdminToolDataImportList = buildFetchModel({
  url: 'tool/data/import/list',
  defaultMethod: 'GET'
});

//数据导入删除
export const SchoolAdminToolDataImportDelete = buildFetchModel({
  url: 'tool/data/import/list',
  defaultMethod: 'POST'
});

//班级删除学生
export const ToolBookStatementStudentCourseDelete = buildFetchModel({
  url: 'tool/book/statement/class/student/delete',
  defaultMethod: 'POST'
});


//数据导入接口
export const SchoolAdminToolDataImportModel = buildFetchModel({
  url: 'tool/data/import',
  defaultMethod: 'POST'
});

//导入进度查询
export const AdminToolDataImportProcessDetail = buildFetchModel({
  url: 'tool/data/import/process',
  defaultMethod: 'GET'
});

//班级学生信息列表
export const ToolBookStatementClassStudentListModel = buildFetchModel({
  url: 'tool/book/statement/class/student/list',
  defaultMethod: 'GET'
});

//课程用书列表
export const SchoolAdminToolBookStatementBookCatalog = buildFetchModel({
  url: 'tool/book/statement/book/catalog',
  defaultMethod: 'GET'
});
//学生选书接口
export const ToolBookStatementClassStudentBookSelectModel = buildFetchModel({
  url: 'tool/book/statement/class/student/book/select',
  defaultMethod: 'POST'
});

//结算批次删除
export const AdminToolBookStatementDeleteModel = buildFetchModel({
  url: 'tool/book/statement/delete',
  defaultMethod: 'POST'
});

//结算课程列表
export const AdminToolBookStatementCourseList = buildFetchModel({
  url: 'tool/book/statement/course/list',
  defaultMethod: 'GET'
});

//编辑课程
export const AdminToolChangeCourseStatementModel = buildFetchModel({
  url: 'tool/book/course/statement/:course_id',
  defaultMethod: 'POST'
});

//删除课程
export const AdminToolBookStatementCourseDeleteModel = buildFetchModel({
  url: 'tool/book/course/:book_statement_id/delete',
  defaultMethod: 'POST'
});
//选择课程用书列表
export const AdminToolChangeBookStatementBookCatalogList = buildFetchModel({
  url: 'tool/book/statement/book/catalog/list',
  defaultMethod: 'GET'
});

//删除课程用书
export const AdminToolBookStatementCourseCatalogDeleteModel = buildFetchModel({
  url: 'tool/book/statement/course/catalog/delete/:book_statement_id',
  defaultMethod: 'POST'
});

//给课程添加教材
export const AdminToolBookStatementCourseCatalogAddBookModel = buildFetchModel({
  url: 'tool/book/statement/course/catalog/addbook/:book_statement_id',
  defaultMethod: 'POST'
});

//更改使用教材
export const AdminToolBookStatementCourseCatalogChangeBookModel = buildFetchModel({
  url: 'tool/book/statement/course/catalog/changebook/:book_statement_book_catalog_id',
  defaultMethod: 'POST'
});

//编辑班级
export const AdminToolBookClassStatementNameModel = buildFetchModel({
  url: 'tool/book/class/statement/:book_statement_class_id',
  defaultMethod: 'POST'
});

//教师课程列表
export const AdminToolBookStatementTeacherCourseList = buildFetchModel({
  url: 'tool/book/statement/teacher/course/list',
  defaultMethod: 'GET'
});

//教师分配用书
export const AdminToolBookStatementTeacherSelectCatalog = buildFetchModel({
  url: 'tool/book/statement/teacher/select/catalog',
  defaultMethod: 'POST'
});

//教师课程删除
export const AdminToolBookStatementTeacherCourseDelete = buildFetchModel({
  url: 'tool/book/statement/teacher/course/delete',
  defaultMethod: 'POST'
});

//教师列表
export const AdminToolBookStatementTeacherList = buildFetchModel({
  url: 'tool/book/statement/teacher/list',
  defaultMethod: 'GET'
});

//删除教师
export const AdminToolBookStatementTeacherDelete = buildFetchModel({
  url: 'tool/book/statement/teacher/delete',
  defaultMethod: 'POST'
});

//班级更改
export const AdminToolBookCourseStatementChooseModel = buildFetchModel({
  url: 'tool/book/course/statement/choose',
  defaultMethod: 'POST'
});

//教师编辑
export const AdminToolBookStatementTeacherEditModel = buildFetchModel({
  url: 'tool/book/statement/teacher/:book_statement_teacher_id/edit',
  defaultMethod: 'POST'
});
//学生编辑创建
export const PublisherToolBookStatementStudentEditModel = buildFetchModel({
  url: 'tool/book/statement/student/create/:book_statement_student_id',
  defaultMethod: 'POST'
});
//学生转班
export const PublisherToolBookStatementStudentChangeClassModel = buildFetchModel({
  url: 'tool/book/statement/student/:book_statement_student_id/change/class',
  defaultMethod: 'POST'
});
//创建班级
export const PublisherToolBookStatementClassCreateModel = buildFetchModel({
  url: 'tool/book/statement/class/create/:book_statement_class_id',
  defaultMethod: 'POST'
});
//批次归档
export const PublisherToolBookStatementArchiveModel = buildFetchModel({
  url: 'tool/book/statement/:book_statement_id/archive',
  defaultMethod: 'POST'
});

//领书申请列表
export const ToolBookCollectionStatementListModel = buildFetchModel({
  url: 'tool/book/statement/student/applications/list',
  defaultMethod: 'GET'
});

//领书申请教材详情列表
export const ToolBookCollectionStatementListDetailModel = buildFetchModel({
  url: 'tool/book/statement/student/class/apply/book/detail',
  defaultMethod: 'GET'
});

//领书申请通过驳回
export const ToolBookCollectionStatementPassRejectModel = buildFetchModel({
  url: 'tool/book/statement/student/class/pass/reject',
  defaultMethod: 'POST'
});

//刷新二维码
export const ToolBookStatementQrCodeModel = buildFetchModel({
  url: 'tool/book/statement/:book_statement_id/qr/code',
  defaultMethod: 'POST'
});
//图书去重 #
export const ToolBookStatementBookCatalogDeleteDuplicateModel = buildFetchModel({
  url: 'tool/book/statement/:book_statement_id/book/catalog/delete/duplicate',
  defaultMethod: 'POST'
});

//结算学院统计
export const ToolBookStatementCollegeTotalModel = buildFetchModel({
  url: 'tool/book/statement/:book_statement_id/college/total',
  defaultMethod: 'GET'
});

//结算单详情
export const ToolBookStatementDetailModel = buildFetchModel({
  url: 'tool/book/statement/:book_statement_id/detail',
  defaultMethod: 'GET'
});
//供应商列表
export const ToolBookStatementProvidersListModel = buildFetchModel({
  url: 'tool/book/statement/providers/list',
  defaultMethod: 'GET'
});
//供应商创建编辑
export const ToolBookStatementProvidersCreateModel = buildFetchModel({
  url: 'tool/book/statement/providers/create/:book_statement_provider_id',
  defaultMethod: 'POST'
});
//供应商删除
export const ToolBookStatementProvidersDeleteModel = buildFetchModel({
  url: 'tool/book/statement/providers/delete',
  defaultMethod: 'POST'
});
//图书更换供应商
export const ToolBookStatementProvidersChangeModel = buildFetchModel({
  url: 'tool/book/statement/provider/change',
  defaultMethod: 'POST'
});
//库存列表
export const ToolBookStatementStocksList = buildFetchModel({
  url: 'tool/book/statement/stocks/list',
  defaultMethod: 'GET',
});
//录入销售
export const ToolBookStatementStocksSalesModel = buildFetchModel({
  url: 'tool/book/statement/stocks/:book_statement_stock_id/sales',
  defaultMethod: 'POST',
});
//课程学生关系列表
export const ToolBookCourseStudentRelationshipListModel = buildFetchModel({
  url: 'tool/book/course/student/relationship/list',
  defaultMethod: 'GET',
});

//教材学生关系列表
export const ToolBookStatementStudentBookCatalogListModel = buildFetchModel({
  url: 'tool/book/statement/student/book/catalog/list',
  defaultMethod: 'GET',
});
//生成批次发书
export const ToolBookStatementGenerateReceiveBookCatalogModel = buildFetchModel({
  url: 'tool/book/statement/:book_statement_id/generate/receive/book/catalog',
  defaultMethod: 'POST'
});
//数据统计
export const ToolBookStatementDataCollectionModel = buildFetchModel({
  url: 'tool/book/statement/:book_statement_id/data/collection',
  defaultMethod: 'GET'
});
//班级应发教材列表
export const ToolBookStatementClassBookCatalogListModel = buildFetchModel({
  url: 'tool/book/statement/class/book/catalog/list',
  defaultMethod: 'GET'
});
//出版社统计
export const ToolBookStatementPressCollectModel = buildFetchModel({
  url: 'tool/book/statement/press/collect',
  defaultMethod: 'GET'
});
//学生跨批次代管费管理----
export const ToolBookStatementStudnetAllManagementCostListModel = buildFetchModel({
  url: 'tool/book/statement/student/all/management/cost/list',
  defaultMethod: 'GET'
});
//批次刷新
export const ToolBookStatementCalculateModel = buildFetchModel({
  url: 'tool/book/statement/:book_statement_id/calculate',
  defaultMethod: 'POST'
});
//图书新建编辑
export const ToolBookStatementBookCatalogUpdateModel = buildFetchModel({
  url: 'tool/book/statement/book/catalog/update/:book_statement_catalog_id',
  defaultMethod: 'POST'
});
//学号查询信息
export const ToolBookStatementStudentCodeSelectModel = buildFetchModel({
  url: 'tool/book/statement/student/code/select',
  defaultMethod: 'GET'
});
//学号查询信息
export const ToolBookStatementStudentCodeSelectsModel = buildFetchModel({
  url: 'tool/book/statement/student/code/secret/select',
  defaultMethod: 'GET'
});
//学生教材删除
export const ToolBookStatementClassCourseDeleteModel = buildFetchModel({
  url: 'tool/book/statement/class/course/delete',
  defaultMethod: 'POST'
});
//学生补订信息导入
export const SchoolAdminToolSupplyDataImportModel = buildFetchModel({
  url: '/tool/data/import',
  defaultMethod: 'POST'
});
//补订信息表
export const ToolBookStatementBookAdditionalListModel = buildFetchModel({
  url: 'tool/book/statement/student/book/catalog/additional/list',
  defaultMethod: 'GET'
});
//学生单个补订书
export const ToolStatementStudentAddBookCatalog = buildFetchModel({
  url: 'tool/book/statement/student/add/book/catalog',
  defaultMethod: 'POST'
});
//所有未领教材删除
export const ToolBookStatementUnreceivedDeleteModel = buildFetchModel({
  url: '/tool/book/statement/:book_statement_id/delete/un/received',
  defaultMethod: 'POST'
});
//新增代管费用
export const ToolBookStatementCostUpperModel = buildFetchModel({
  url: '/tool/book/statement/:book_statement_id/student/management/cost/upper',
  defaultMethod: 'POST'
});
// 课程教材关系删除
export const ToolStatementManageCourseAndTextbookDeleteModel = buildFetchModel({
  url: '/tool/book/course/book/catalog/delete',
  defaultMethod:'POST'
})
//课程学生关系删除
export const ToolStatementManageCourseAndStudentDeleteModel = buildFetchModel({
  url: '/tool/book/course/student/delete',
  defaultMethod: 'POST'
})



// WEBPACK FOOTER //
// ./src/model/AdminModel.js